import request from '@/request/index.js'


/**
 *  解锁剧集
 *    入参:
 *      video_id--integer--必须--视频id
 *      episode--integer--必须--第几集
 *    出参:  http://yapi.yunxiacn.com:3000/project/136/interface/api/10386
 *
 */
export function unlockEpisode(data) {
  return request({
    url: '/video/unlockEposide',
    method: 'POST',
    data
  })
}
/**
 *  获取短剧详情
 *    入参:
 *      video_id--integer--必须--视频id
 *      episode--integer--必须--第几集
 *      filter_category_list--array--非必须--运营标签id
 *      filter_grade_id--array--非必须--评级标签id
 *    出参:  http://yapi.yunxiacn.com:3000/project/136/interface/api/10386
 *
 */
export function getVideoDetail(data) {
  return request({
    url: '/video/popularize',
    method: 'POST',
    data
  })
}


/**
 *  检测视频过滤状态合并获取视频列表
 *    入参:
 *      video_id--integer--非必须--视频id
 *      filter_category_list--array--非必须--运营标签id
 *      filter_grade_id--array--非必须--评级标签id
 *    出参:  http://yapi.yunxiacn.com/project/136/interface/api/11558
 *
 */
export function getVideoListNew(data) {
  return request({
    url: '/video/videoDetailListAndFilterStatus',
    method: 'POST',
    data
  })
}

/*
  根据分类获取视频列表
    label_id 视频类别, 不传默认为热门列表
    page 第几页，从 1开始
    page_size 一页需要的视频数量
    filter_copyright_category 审核状态过滤
    force_version ab特性指定的videoId对应版本
*/
export function getCategoryVideoList(data) {
  return request({
    url: '/video/hotList',
    method: 'POST',
    data
  })
}

/*
  获取最新列表
    filter_copyright_category 审核状态过滤
    force_version ab特性指定的videoId对应版本
*/
export function getNewVideoList(data) {
  return request({
    url: '/video/newList',
    method: 'POST',
    data
  })
}
